<script>
  import OverpanelControl from '../OverpanelControl/OverpanelControl.svelte';
  import StyledRadioButtonLabel from '../StyledRadioButtonLabel/StyledRadioButtonLabel.svelte';
  import { overpanelMap, closeOverpanel } from '../../stores/overpanelControl';
  import { drug, drugData, setStrength } from '../../stores/drug';

  let { title, dataTestId = 'drug-strength-overpanel', closeCallback = () => {} } = $props();

  let options = $derived($drug ? $drugData.form.doses : []);

  const onChange = (e) => {
    setStrength(options.find((option) => option.value === e.target.value));
  };

  const handleOnMouseUp = (e) => {
    onChange(e);
    closeOverpanel('drugStrength');
    closeCallback();
  };

  const handleKeyPress = (e) => {
    if (e.keyCode == 13) handleOnMouseUp(e);
  };
</script>

{#if $overpanelMap.has('drugStrength') && $drug}
  <OverpanelControl {title} {closeCallback} overpanelKey="drugStrength">
    <form class="min-h-full bg-gray-mercury" onsubmit={(e) => e.preventDefault()}>
      <fieldset data-testid={dataTestId} onchange={onChange}>
        <legend class="visually-hidden">{title}</legend>
        <div class="flex flex-row flex-wrap">
          {#each options as { label, value }, i}
            <StyledRadioButtonLabel
              id={`form-${i}`}
              {value}
              selected={$drugData.strength.value === value}
              onMouseUp={handleOnMouseUp}
              onKeyPress={handleKeyPress}
            >
              {label}
            </StyledRadioButtonLabel>
          {/each}
        </div>
      </fieldset>
    </form>
  </OverpanelControl>
{/if}
